export const translations = {
  nav: {
    home: { en: 'Home', ur: 'ہوم' },
    about: { en: 'About', ur: 'تعارف' },
    courses: { en: 'Courses', ur: 'کورسز' },
    admissions: { en: 'Admissions', ur: 'داخلہ' },
    contact: { en: 'Contact', ur: 'رابطہ' }
  },
  home: {
    hero_title: { en: 'Jamia Ishatul Khair', ur: 'جامعہ اشاعتُ الخیر' },
    hero_subtitle: {
      en: 'A Center of Islamic Knowledge and Spiritual Excellence',
      ur: 'اسلامی علم اور روحانی بہتری کا مرکز'
    },
    mission_title: { en: 'Our Mission', ur: 'ہمارا مشن' },
    mission_text: {
      en: 'To provide authentic Islamic education combining traditional scholarship with contemporary understanding, nurturing students who embody Islamic values and contribute positively to society.',
      ur: 'روایتی علم کو عصری فہم کے ساتھ ملا کر صحیح اسلامی تعلیم فراہم کرنا، ایسے طلبا کی پرورش کرنا جو اسلامی اقدار کی نمائندگی کریں اور معاشرے میں مثبت کردار ادا کریں۔'
    },
    courses_title: { en: 'Our Courses', ur: 'ہمارے کورسز' },
    aalim_title: { en: 'Aalim Course', ur: 'عالم کورس' },
    aalim_desc: {
      en: 'Comprehensive Islamic scholarship program covering Fiqh, Hadith, Tafsir, and Arabic',
      ur: 'فقہ، حدیث، تفسیر اور عربی پر مشتمل جامع اسلامی علمی پروگرام'
    },
    hafiz_title: { en: 'Hafiz Course', ur: 'حافظ کورس' },
    hafiz_desc: {
      en: 'Complete memorization of the Holy Quran with proper Tajweed and understanding',
      ur: 'مکمل تجوید اور سمجھ کے ساتھ قرآن مجید کی حفظ'
    },
    cta_learn: { en: 'Learn More', ur: 'مزید جانیں' },
    cta_apply: { en: 'Apply Now', ur: 'ابھی اپلائی کریں' },
    timings: { en: 'Open 24 Hours', ur: '24 گھنٹے کھلا' }
  },
  about: {
    title: { en: 'About Jamia Ishatul Khair', ur: 'جامعہ اشاعتُ الخیر کے بارے میں' },
    history_title: { en: 'Our History', ur: 'ہماری تاریخ' },
    history_text: {
      en: 'Jamia Ishatul Khair has been serving the community for years, providing quality Islamic education and nurturing future scholars. Our institution stands as a beacon of knowledge in Hyderabad, Telangana.',
      ur: 'جامعہ اشاعتُ الخیر برسوں سے کمیونٹی کی خدمت کر رہی ہے، معیاری اسلامی تعلیم فراہم کرتی ہے اور مستقبل کے علماء کی پرورش کرتی ہے۔ ہمارا ادارہ حیدرآباد، تلنگانہ میں علم کی روشنی کے طور پر کھڑا ہے۔'
    },
    vision_title: { en: 'Our Vision', ur: 'ہماری نظر' },
    vision_text: {
      en: 'To be a leading center of Islamic education that produces scholars who understand both traditional Islamic sciences and contemporary challenges, contributing meaningfully to society.',
      ur: 'اسلامی تعلیم کا ایک معروف مرکز بننا جو ایسے علماء پیدا کرے جو روایتی اسلامی علوم اور عصری چیلنجز دونوں کو سمجھیں، معاشرے میں بامعنی کردار ادا کریں۔'
    },
    mission_title: { en: 'Our Mission', ur: 'ہمارا مشن' },
    mission_text: {
      en: 'To provide comprehensive Islamic education that combines memorization of the Quran, understanding of Islamic jurisprudence, and development of strong moral character.',
      ur: 'جامع اسلامی تعلیم فراہم کرنا جو قرآن کی حفظ، اسلامی فقہ کی سمجھ، اور مضبوط اخلاقی کردار کی نشوونما کو یکجا کرے۔'
    },
    principal_title: { en: 'Message from the Principal', ur: 'پرنسپل کا پیغام' },
    principal_text: {
      en: 'At Jamia Ishatul Khair, we are committed to nurturing students who excel in both Islamic knowledge and moral character. Our experienced faculty ensures that each student receives personalized attention and guidance on their educational journey.',
      ur: 'جامعہ اشاعتُ الخیر میں، ہم ایسے طلبا کی پرورش کے لیے پرعزم ہیں جو اسلامی علم اور اخلاقی کردار دونوں میں بہترین ہوں۔ ہمارا تجربہ کار اساتذہ یقینی بناتے ہیں کہ ہر طالب علم کو اپنے تعلیمی سفر میں ذاتی توجہ اور رہنمائی ملے۔'
    }
  },
  courses: {
    title: { en: 'Our Courses', ur: 'ہمارے کورسز' },
    subtitle: {
      en: 'Comprehensive Islamic Education Programs',
      ur: 'جامع اسلامی تعلیمی پروگرام'
    },
    aalim: {
      title: { en: 'Aalim Course', ur: 'عالم کورس' },
      duration: { en: 'Duration: 5 Years', ur: 'مدت: 5 سال' },
      desc: {
        en: 'The Aalim course is a comprehensive Islamic scholarship program that provides in-depth knowledge of Islamic sciences.',
        ur: 'عالم کورس ایک جامع اسلامی علمی پروگرام ہے جو اسلامی علوم کی گہرائی میں معلومات فراہم کرتا ہے۔'
      },
      subjects: { en: 'Subjects Covered:', ur: 'مضامین:' },
      subject_list: {
        en: ['Quran with Tafsir', 'Hadith Studies', 'Islamic Jurisprudence (Fiqh)', 'Arabic Language & Grammar', 'Islamic History', 'Aqeedah (Islamic Belief)', 'Seerah (Life of Prophet)', 'Comparative Religion'],
        ur: ['قرآن بمع تفسیر', 'حدیث کا مطالعہ', 'اسلامی فقہ', 'عربی زبان اور گرامر', 'اسلامی تاریخ', 'عقیدہ', 'سیرت النبی', 'تقابلی مذاہب']
      }
    },
    hafiz: {
      title: { en: 'Hafiz Course', ur: 'حافظ کورس' },
      duration: { en: 'Duration: 2-4 Years', ur: 'مدت: 2-4 سال' },
      desc: {
        en: 'The Hafiz program focuses on complete memorization of the Holy Quran with proper pronunciation and Tajweed rules.',
        ur: 'حافظ پروگرام مکمل تلفظ اور تجوید کے قواعد کے ساتھ قرآن مجید کی مکمل حفظ پر توجہ مرکوز کرتا ہے۔'
      },
      features: { en: 'Program Features:', ur: 'پروگرام کی خصوصیات:' },
      feature_list: {
        en: ['Complete Quran Memorization', 'Tajweed Rules & Application', 'Proper Pronunciation Training', 'Regular Revision Sessions', 'Individual Attention', 'Qualified Huffaz as Teachers', 'Nazra & Tarteel Practice', 'Monthly Evaluation'],
        ur: ['قرآن کی مکمل حفظ', 'تجوید کے قواعد اور ان کا استعمال', 'صحیح تلفظ کی تربیت', 'باقاعدہ نظرثانی کے سیشن', 'انفرادی توجہ', 'اہل حفاظ بطور اساتذہ', 'ناظرہ اور ترتیل کی مشق', 'ماہانہ تشخیص']
      }
    }
  },
  admissions: {
    title: { en: 'Admissions', ur: 'داخلہ' },
    subtitle: {
      en: 'Join Our Islamic Education Journey',
      ur: 'ہمارے اسلامی تعلیمی سفر میں شامل ہوں'
    },
    process_title: { en: 'Admission Process', ur: 'داخلہ کا عمل' },
    process_steps: {
      en: [
        'Fill out the admission form with required details',
        'Submit necessary documents and certificates',
        'Attend the interview with the Principal or faculty',
        'Complete the admission formalities upon selection'
      ],
      ur: [
        'ضروری تفصیلات کے ساتھ داخلہ فارم بھریں',
        'ضروری دستاویزات اور سرٹیفکیٹ جمع کرائیں',
        'پرنسپل یا اساتذہ کے ساتھ انٹرویو میں شرکت کریں',
        'منتخب ہونے پر داخلہ کی رسمی کارروائی مکمل کریں'
      ]
    },
    eligibility_title: { en: 'Eligibility Criteria', ur: 'اہلیت کا معیار' },
    eligibility: {
      aalim: {
        title: { en: 'For Aalim Course:', ur: 'عالم کورس کے لیے:' },
        list: {
          en: ['Minimum age: 12 years', 'Completed primary education', 'Basic knowledge of Urdu/Arabic (preferred)', 'Commitment to full-time study'],
          ur: ['کم سے کم عمر: 12 سال', 'پرائمری تعلیم مکمل', 'اردو/عربی کا بنیادی علم (ترجیحی)', 'کل وقتی مطالعہ کا عزم']
        }
      },
      hafiz: {
        title: { en: 'For Hafiz Course:', ur: 'حافظ کورس کے لیے:' },
        list: {
          en: ['Minimum age: 7 years', 'Ability to read Arabic/Urdu', 'Good memory retention', 'Parental support for regular attendance'],
          ur: ['کم سے کم عمر: 7 سال', 'عربی/اردو پڑھنے کی صلاحیت', 'اچھی یادداشت', 'باقاعدہ حاضری کے لیے والدین کا تعاون']
        }
      }
    },
    documents_title: { en: 'Required Documents', ur: 'ضروری دستاویزات' },
    documents: {
      en: ['Birth Certificate or Age Proof', 'Previous Educational Certificates', 'Identity Proof (Aadhar Card)', 'Recent Passport Size Photographs', 'Residential Proof', 'Parent/Guardian Contact Details'],
      ur: ['پیدائش کا سرٹیفکیٹ یا عمر کا ثبوت', 'سابقہ تعلیمی سرٹیفکیٹ', 'شناختی ثبوت (آدھار کارڈ)', 'حالیہ پاسپورٹ سائز تصاویر', 'رہائشی ثبوت', 'والدین/سرپرست کے رابطے کی تفصیلات']
    },
    session_title: { en: 'Academic Session', ur: 'تعلیمی سیشن' },
    session_text: {
      en: 'New admissions are typically open throughout the year. However, it is recommended to apply at the beginning of the academic session for a structured learning experience.',
      ur: 'نئے داخلے عام طور پر سال بھر کھلے رہتے ہیں۔ تاہم، منظم سیکھنے کے تجربے کے لیے تعلیمی سیشن کے آغاز میں درخواست دینے کی سفارش کی جاتی ہے۔'
    }
  },
  contact: {
    title: { en: 'Contact Us', ur: 'ہم سے رابطہ کریں' },
    subtitle: {
      en: 'Get in touch with us for any inquiries',
      ur: 'کسی بھی استفسار کے لیے ہم سے رابطہ کریں'
    },
    form_title: { en: 'Send us a Message', ur: 'ہمیں پیغام بھیجیں' },
    name: { en: 'Name', ur: 'نام' },
    email: { en: 'Email', ur: 'ای میل' },
    phone: { en: 'Phone Number', ur: 'فون نمبر' },
    subject: { en: 'Subject', ur: 'موضوع' },
    message: { en: 'Message', ur: 'پیغام' },
    submit: { en: 'Send Message', ur: 'پیغام بھیجیں' },
    info_title: { en: 'Contact Information', ur: 'رابطہ کی معلومات' },
    address_label: { en: 'Address', ur: 'پتہ' },
    phone_label: { en: 'Phone', ur: 'فون' },
    timings_label: { en: 'Timings', ur: 'اوقات' },
    success: { en: 'Message sent successfully!', ur: 'پیغام کامیابی سے بھیجا گیا!' },
    error: { en: 'Failed to send message. Please try again.', ur: 'پیغام بھیجنے میں ناکام۔ براہ کرم دوبارہ کوشش کریں۔' }
  },
  theme: {
    light: { en: 'Light', ur: 'روشنی' },
    dark: { en: 'Dark', ur: 'تاریک' }
  }
};
